"use client";

import { useState, useEffect } from "react";
import { Button } from "@heroui/react";

interface ShowMoreNewsButtonProps {
  totalItems: number;
  initialDisplay: number;
}

export default function ShowMoreNewsButton({
  totalItems,
  initialDisplay,
}: ShowMoreNewsButtonProps) {
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    // Apply CSS to hide items beyond initial display
    const items = document.querySelectorAll(".news-grid-item");
    items.forEach((item, index) => {
      if (!showAll && index >= initialDisplay) {
        (item as HTMLElement).style.display = "none";
      } else {
        (item as HTMLElement).style.display = "";
      }
    });
  }, [showAll, initialDisplay]);

  if (totalItems <= initialDisplay) return null;

  return (
    <>
      {!showAll && (
        <div className="flex flex-col items-center mt-8 gap-4">
          <p className="text-sm text-muted">
            Showing {initialDisplay} of {totalItems} news articles
          </p>
          <Button
            onPress={() => setShowAll(true)}
            className="px-6 py-3 bg-theme-neon text-on-accent font-semibold text-sm rounded-md hover:bg-theme-neon/90 transition-colors"
          >
            Show All News ({totalItems - initialDisplay} more)
          </Button>
        </div>
      )}

      {showAll && (
        <div className="flex flex-col items-center mt-8 gap-4">
          <p className="text-sm text-muted">
            Showing all {totalItems} news articles
          </p>
          <Button
            onPress={() => {
              setShowAll(false);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="px-6 py-3 bg-ink/10 text-ink font-semibold text-sm rounded-md hover:bg-ink/20 transition-colors"
          >
            Show Less
          </Button>
        </div>
      )}
    </>
  );
}
